const WodaGrupoweTHead = () => {

    return (
        <thead>
            <tr>
                <th className="imiona">
                    Imię i nazwisko
                </th>
                <th>
                    Adres
                </th>
                <th>
                    Czy uwzględniony
                </th>
                <th className="zimna">
                    Stan początek
                </th>
                <th className="zimna">
                    Stan koniec
                </th>
                <th className="zimna">
                    Zużycie
                </th>
                <th className="ciepla">
                    Stan początek
                </th>
                <th className="ciepla">
                    Stan koniec
                </th>
                <th className="ciepla">
                    Zużycie
                </th>
                <th>
                    Zużycie razem
                </th>
                <th>

                </th>
            </tr>
        </thead>
    )
}

export default WodaGrupoweTHead;